import VideoPresentation from "./videoPresentation";

export default VideoPresentation;
